
<template>
  <div class="inquiry-company">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">设备列表</div>
        <div class="select-container" style="margin-top: 0px;">
          <div class="select-container-box">
            <span>设备类型</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="deviceType">
              <el-option
                v-for="(item, index) in deviceTypeList" 
                :key="index" 
                :label="item.value" 
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>供电状态</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="powerstatus">
              <el-option
                v-for="(item, index) in statusList" 
                :key="index" 
                :label="item.value" 
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入" v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div>
           
          <div class="select-container-box">
            <el-button size="small"  type="info" plain  class="query" @click="search(1)">查询</el-button>
          </div>
          </div>
        </div>
       <div class="table-container">
        <el-table
          :data="list"
          style="width:100%" 
          size="medium" 
          :span-method="objectSpanMethod"
          border
          >
            <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
          <el-table-column 
          prop="enterpriseName" 
          label="公司名称" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="deviceType" 
          label="设备类型" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="equipmentName" 
          label="设备名称" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="iotId" 
          label="设备号" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="simCardSerialNumber" 
          label="SIM卡序列号" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
           <el-table-column 
          prop="powerStatus" 
          label="设备供电状态"
          :formatter="powerStatus"
          show-overflow-tooltip 
          align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";

export default {
  name: "LossReport",
  data() {
    return {
      keyword: "",
      spanArr: [],
      spanArr1: [],
      list: [],
      deviceType: "",
      powerstatus: "",
      deviceTypeList: [
        {
          key: "",
          value: "全部"
        },
        {
          key: 1,
          value: "水贝RTU"
        },
        {
          key: 2,
          value: "塔石DTU"
        },
        {
          key: 3,
          value: "智能排插"
        },
        {
          key: 4,
          value: "笔笔发DTU"
        },
        {
          key: 5,
          value: "渔控仪"
        }
      ],
      statusList: [
        {
          key: "",
          value: "全部"
        },
        {
          key: 0,
          value: "离线"
        },
        {
          key: 1,
          value: "电源供电"
        },
        {
          key: 2,
          value: "电池供电"
        }
      ]
    };
  },
  async mounted() {
    this.search();
  },
  methods: {
    ...mapActions(modules.user, ["getPlatformEquipmentList"]), //基地
    // 设备供电状态
    powerStatus(row, column) {
      if (row.powerStatus == 0) {
        return <div style="color:gray">离线</div>;
      } else if (row.powerStatus == 1) {
        return <div style="color:#0fce82">电源供电</div>;
      } else if (row.powerStatus == 2) {
        return <div style="color:#ff812d">电池供电</div>;
      }
    },
    async search() {
      this.list = await this.getPlatformEquipmentList({
        DeviceType: this.deviceType,
        PowerStatus: this.powerstatus,
        Keyword: this.keyword
      });
      this.rowSpan();
      this.rowSpan1();
    },
    rowSpan() {
      let contactDot = 0;
      this.spanArr = [];
      this.list.forEach((item, index) => {
        console.log(item);
        item.index = index;
        if (index === 0) {
          this.spanArr.push(1);
        } else {
          if (item.enterpriseName === this.list[index - 1].enterpriseName) {
            this.spanArr[contactDot] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            contactDot = index;
          }
        }
      });
    },
    rowSpan1() {
      let contactDot = 0;
      this.spanArr1 = [];
      this.list.forEach((item, index) => {
        console.log(item);
        item.index = index;
        if (index === 0) {
          this.spanArr1.push(1);
        } else {
          if (
            item.enterpriseName === this.list[index - 1].enterpriseName &&
            item.deviceType === this.list[index - 1].deviceType
          ) {
            this.spanArr1[contactDot] += 1;
            this.spanArr1.push(0);
          } else {
            this.spanArr1.push(1);
            contactDot = index;
          }
        }
      });
    },
    //合并相同基地
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    }
  }
};
</script>
<style lang="stylus" >
.inquiry-company
  .el-table{
     .el-table__body tbody td{
        border-bottom:1px solid #eee;
     }
     .el-table__row:nth-of-type(even) {
          background: #fff;
          z-index: 9999;
      }
  }
  .total{
      .el-select__tags{
      top:65%;
      height: 30px;
      overflow: auto;
    }
    .el-input__suffix{
      top:6px;
    }
    .is-focus .el-input__suffix {
      top:0px;
    }
  }
  .select-container-box:nth-child(1),.select-container-box:nth-child(3)
    .el-input--small
      width 135px!important
      height 38px!important
      min-width 135px!important
  .select-container-box:nth-child(6),.select-container-box:nth-child(7)
    .el-input--small
      width 96px!important
      height 38px!important
      min-width 96px!important
  .select-container-box:nth-child(9)
    .add,.query
      width:80px!important

  .scroll-box3
    width: 100%;
    max-height:550px;
    overflow: auto;
    overflow-x:hidden;
  .table-package
    width 100%
    border-collapse collapse
    // border 1px #ddd solid
    border:none;
  .table-thead
    border-top: 2px solid rgb(51,137,255);
    
    >tr th
      width:294px;
      text-align center
      height: 50px;
      font-size: 14px;
      line-height: 50px;
      color #666;
      font-weight bold
      border: 1px solid #e0e0e0;
      border-bottom: 1px solid rgb(51,137,255);
      background-color: #f7f7f7;
  .table-tbodys
    :hover
      background:#c3e3ff;
    tr
      text-align center
      height 37px
      line-height 37px
      border: 1px solid #ddd;
      border:none;
      background-color #fff
    td
      width:294px;
      border 1px solid #e0e0e0
      color: #666;
      border-top:none;
      vertical-align:middle;
  .table-tfoot
    tr>td
      text-align center
      height 37px
      line-height 37px
      color: #333;
      font-size: 14px;
    .row
      font-size 14px
      background-color #fff
      font-weight bold

      >td
        width:294px;
        text-align center
        border 1px solid #e0e0e0
        // color: #666;
        border-top:none;
        font-weight:bold;
  .hidden
    display: none
</style>
